/**
 * Created by shubham on 27/2/18.
 */

import { Component, OnInit, OnDestroy,ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from './loader.service';
import { LoaderState } from './loader';
import { MdDialog, MdDialogRef } from '@angular/material';
import { Router,NavigationEnd } from '@angular/router';


@Component({
    selector: 'angular-loader',
    template: require('./loader.component.html'),
    styles: [require('./loader.component.css')]
})
export class LoaderComponent implements OnInit {

    show:boolean = false;
    isLogin:boolean = false;

    private subscription: Subscription;

    constructor(
        private router: Router,private loaderService: LoaderService,private chRef: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
             if ((evt instanceof NavigationEnd)) {
                 if(evt['url'] == '/login'){
                     this.isLogin = true;
                 } else {
                     this.isLogin = false;
                }
            }
        });

        this.subscription = this.loaderService.loaderState
         .subscribe((state: LoaderState) => {
             this.show = state.show;
             if(this.isLogin) {
                 this.chRef.detectChanges();
            }
         });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/loader/loader.component.ts